import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <SiteHeader />
      <main className="flex-1 px-4 md:px-8 py-20 md:py-28 flex items-center justify-center">
        <div className="w-full rounded-lg border border-background-200 bg-background-50 py-20 px-6 text-center">
          <p className="font-heading text-6xl md:text-7xl font-bold text-background-300">404</p>
          <h1 className="mt-5 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            这条档案好像不存在
          </h1>
          <p className="mt-3 text-sm text-foreground-500">
            你访问的路径是 <span className="text-foreground-700">{location.pathname}</span>
          </p>
          <p className="mt-2 text-sm text-foreground-600">可能链接有误，或者这条档案已经被移动。</p>
          <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-home-4-line" />
              回到首页
            </Link>
            <Link
              to="/archive"
              className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-700 whitespace-nowrap hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer"
            >
              <i className="ri-folder-open-line" />
              浏览档案库
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}